import { MenuItem } from "@chakra-ui/react";
import { useEntityConfirmDelete } from "features/entities/EntityDelete";
import { useGlobalEntityRetrieveSuspense } from "gen/endpoints/global-entity/global-entity";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Restricted } from "shared/components/access/Restricted";
import PageBody from "shared/components/layout/PageBody";
import PageContainer from "shared/components/layout/PageContainer";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageMenu } from "shared/components/layout/PageMenu";
import { PageTabs } from "shared/components/layout/PageTabs";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const EntityEditPage: React.FC = () => {
  const { t } = useTranslation(["common", "entity"]);
  const navigate = useNavigate();

  const { entityId } = useRequiredStringParams();

  const { data: entity } = useGlobalEntityRetrieveSuspense(entityId);

  const backPath = rootRoute({}).entities({}).$;

  const confirmEntityDelete = useEntityConfirmDelete();
  const onClickDelete = async () => {
    const success = await confirmEntityDelete(entityId);
    if (success) {
      navigate(backPath);
    }
  };

  return (
    <PageContainer>
      <PageContent>
        <PageHeader
          title={entity.legal_name}
          backButton={{
            title: t("common:entities"),
            path: backPath,
          }}
          actions={
            <Restricted permission={PermissionTypeEnum.config}>
              <PageMenu>
                <MenuItem className="destructive" onClick={onClickDelete}>
                  {t("common:delete")}
                </MenuItem>
              </PageMenu>
            </Restricted>
          }
        />
        <PageBody>
          <PageTabs context={{ entity }} />
        </PageBody>
      </PageContent>
    </PageContainer>
  );
};
